import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tag", "hiddenInputs"];
  static values = {
    selected: { type: Array, default: [] }
  };

  connect() {
    // Track selections by interest NAME. The tags expose the name via
    // data-interest (dataset.interest), and InterestsController#update reads
    // params[:interests] and resolves records by name. (Earlier code read a
    // non-existent dataset.interestId and submitted interest_ids[], so every
    // value came through blank and no interest was ever saved.)
    this.selectedValue = this.selectedValue.map(String);
    const selectedSet = new Set(this.selectedValue);
    this.tagTargets.forEach(tag => {
      tag.classList.toggle("selected", selectedSet.has(tag.dataset.interest));
    });
    this.renderHiddenInputs();
  }

  filter(event) {
    const searchTerm = event.target.value.toLowerCase();
    this.tagTargets.forEach(tag => {
      tag.style.display = tag.textContent.toLowerCase().includes(searchTerm) ? "flex" : "none";
    });
  }

  toggle(event) {
    const tag = event.currentTarget;
    const name = tag.dataset.interest;
    if (!name) return;
    if (this.selectedValue.includes(name)) {
      this.selectedValue = this.selectedValue.filter(i => i !== name);
      tag.classList.remove("selected");
    } else {
      this.selectedValue = [...this.selectedValue, name];
      tag.classList.add("selected");
    }
    this.dispatchUpdate();
    this.renderHiddenInputs();
  }

  dispatchUpdate() {
    this.dispatch("update", { detail: { count: this.selectedValue.length } });
  }

  renderHiddenInputs() {
    if (!this.hasHiddenInputsTarget) return;
    this.hiddenInputsTarget.innerHTML = "";
    this.selectedValue.forEach(value => {
      const input = document.createElement("input");
      input.type = "hidden";
      // interests[] with the name — InterestsController#update reads params[:interests].
      input.name = "interests[]";
      input.value = value;
      this.hiddenInputsTarget.appendChild(input);
    });
  }
}
